// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1Ah2_","text":"SelectPayment_text__3hUiL","title":"SelectPayment_title__CITek","btn":"SelectPayment_btn__35Fzt"};